import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import css from './Debugger.scss';

type State = any;

class Debugger extends Component<{}, State> {
	state = {
		value: null,
	};

	componentDidMount() {
		// @ts-expect-error ts-migrate FIXME
		window.__storyDebug = this.setValue;
	}

	setValue = value => {
		this.setState({
			value,
		});
	};

	render() {
		const Content = (
			<div className={css.debugger}>
				<textarea value={JSON.stringify(this.state.value, null, 3)} />
				<button type="button" onClick={() => this.setValue(null)}>
					hide
				</button>
			</div>
		);

		return this.state.value && ReactDOM.createPortal(Content, document.body);
	}
}

export default Debugger;
